module.exports = __webpack_public_path__ + "img/231.b22ce5ab.jpg";